import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-page-size-select',
  imports: [CommonModule, MatMenuModule],
  templateUrl: './page-size-select.html',
  styleUrl: './page-size-select.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PageSizeSelect),
      multi: true,
    },
  ],
})
export class PageSizeSelect implements ControlValueAccessor {
  @Input() sizes: number[] = [10, 20, 50, 100];

  value = 10;
  disabled = false;

  private onChange: (value: number) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(value: number): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
